<template>
  <section class="agent-command">
    <div class="ac-head">
      <span class="ac-mark">✦</span>
      <div>
        <strong>今天要做什么？</strong>
        <small>
          说出目标，Agent 会自己查数据、生成、审核并发布。
          自动发布{{ autoPublish ? '已开启' : '未开启，发布前会请你确认' }}。
        </small>
      </div>
    </div>
    <div class="ac-input">
      <el-input
        v-model="text"
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 5 }"
        resize="none"
        placeholder="例如：把今天过审还没发的小红书笔记发到全部小红书账号，间隔 2 分钟"
        @keydown.enter="onEnter"
      />
      <el-button type="primary" :icon="Promotion" :loading="isProcessing" @click="submit">
        交给 Agent
      </el-button>
    </div>
    <div class="ac-suggest">
      <button v-for="s in suggestions" :key="s" type="button" @click="use(s)">{{ s }}</button>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'
import { Promotion } from '@element-plus/icons-vue'
import { useAgentStore } from '../../stores/agentStore'

const SUGGESTIONS = [
  '把过审还没发布的文章发到对应平台的全部可用账号',
  '看看最近 7 天发布失败的任务，告诉我原因和怎么处理',
  '给小红书写 3 篇写作技巧笔记，过审后存草稿',
  '最近内容任务进度怎么样？',
]

export default {
  name: 'AgentCommandBar',
  setup() {
    const agent = useAgentStore()
    const text = ref('')

    const submit = async () => {
      const t = text.value.trim()
      if (!t || agent.isProcessing.value) return
      text.value = ''
      await agent.askInNewConversation(t)
    }

    const onEnter = (e) => {
      if (e.isComposing || e.keyCode === 229 || e.shiftKey) return
      e.preventDefault()
      submit()
    }

    const use = (s) => {
      text.value = s
    }

    return {
      text,
      submit,
      onEnter,
      use,
      suggestions: SUGGESTIONS,
      isProcessing: agent.isProcessing,
      autoPublish: agent.autoPublish,
      Promotion,
    }
  },
}
</script>

<style scoped>
.agent-command {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px 20px;
  margin-bottom: 16px;
  border-radius: var(--mp-radius-lg);
  border: 1px solid #dfe7fb;
  background: linear-gradient(135deg, #f3f7ff 0%, #faf6ff 100%);
}

.ac-head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ac-mark {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: var(--mp-text);
  color: #c9d7ff;
  font-size: 16px;
  flex-shrink: 0;
}

.ac-head strong {
  display: block;
  font-size: 15px;
  color: var(--mp-text);
}

.ac-head small {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: var(--mp-text-secondary);
}

.ac-input {
  display: flex;
  gap: 10px;
  align-items: flex-end;
}

.ac-input .el-textarea {
  flex: 1;
}

.ac-input :deep(.el-textarea__inner) {
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  box-shadow: 0 0 0 1px var(--mp-border) inset;
}

.ac-suggest {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ac-suggest button {
  border: 1px solid var(--mp-border);
  background: rgba(255, 255, 255, 0.8);
  border-radius: 999px;
  padding: 5px 12px;
  font: inherit;
  font-size: 12px;
  color: var(--mp-text-secondary);
  cursor: pointer;
}

.ac-suggest button:hover {
  border-color: var(--mp-accent);
  color: var(--mp-accent);
}

@media (max-width: 768px) {
  .agent-command {
    padding: 14px;
  }

  .ac-input {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
